import { defineMessages } from "react-intl";

export const messages = defineMessages({
  openGraphiQL: {
    id: "PDw0YN",
    defaultMessage: "Open this product in GraphiQL",
    description: "open new window button",
  },
  tabGeneral: {
    id: 'orT773',
    defaultMessage: "General",
    description: "product update tab label",
  },
  tabVariants: {
    id: 'l0t4lk',
    defaultMessage: "Variants & Pricing",
    description: "product update tab label",
  },
  tabFitment: {
    id: 'gkg3f2',
    defaultMessage: "Fitments",
    description: "product update tab label",
  },
  tabSeo: {
    id: 'fKwAip',
    defaultMessage: "SEO & Meta Keywords",
    description: "product update tab label",
  },
  tabMetadata: {
    id: 'DGyijp',
    defaultMessage: "Metadata",
    description: "product update tab label",
  },
  tabWsm: {
    id: 'RrnOVS',
    defaultMessage: "Options, charges & compliance",
    description: "product update tab label",
  },
});
